import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetStartupDataResponse } from "./GetStartupDataResponse";

const ENDPOINT = "/options/startup_data";

export class GetStartupDataCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    public async execute(): Promise<GetStartupDataResponse> {
        var res = await this.executeCommand();
        return new GetStartupDataResponse(res);
    }
}
